import { objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isDeleteFreeTrialDeveloperResult = objectOf({
  info: string,
});

export const isPutFreeTrialDeveloperResult = objectOf({
  info: string,
});
